import './Legal.css';

export default function Privacy() {
  return (
    <div className="legal-page">
      <div className="legal-card">
        <div className="legal-header">
          <span className="mono legal-tag">PuzzleForge</span>
          <h1 className="mono">Privacy Policy</h1>
          <p className="legal-date mono">Last updated: March 24, 2026</p>
        </div>

        <div className="legal-body">

          <section>
            <h2>1. Information We Collect</h2>
            <p>We collect your email address when you register. We also collect gameplay data such as puzzle attempts, streaks, and scores to provide the Service.</p>
          </section>

          <section>
            <h2>2. How We Use Your Information</h2>
            <p>We use your information to: operate and improve the Service; send account-related emails; process payments; and analyze usage patterns to improve puzzle quality.</p>
          </section>

          <section>
            <h2>3. Data Sharing</h2>
            <p>We do not sell your personal data. We share data only with service providers necessary to operate PuzzleForge, including Paddle (payment processing) and Railway (hosting). These providers are contractually bound to protect your data.</p>
          </section>

          <section>
            <h2>4. Cookies</h2>
            <p>We use session cookies to keep you logged in. We do not use tracking or advertising cookies.</p>
          </section>

          <section>
            <h2>5. Data Retention</h2>
            <p>We retain your account data for as long as your account is active. You may request deletion of your account and data by contacting support@puzzleforge.io.</p>
          </section>

          <section>
            <h2>6. Security</h2>
            <p>We use industry-standard security measures including encrypted passwords and HTTPS. No method of transmission is 100% secure, but we strive to protect your data.</p>
          </section>

          <section>
            <h2>7. Your Rights</h2>
            <p>You have the right to access, correct, or delete your personal data. Contact us at support@puzzleforge.io to exercise these rights.</p>
          </section>

          <section>
            <h2>8. Contact</h2>
            <p>For privacy questions, contact us at <a href="mailto:support@puzzleforge.io">support@puzzleforge.io</a>.</p>
          </section>

        </div>
      </div>
    </div>
  );
}
